import {HashLink} from 'react-router-hash-link';
// const profile = require('../images/Hero.jpg')
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/Hero.css';

const Hero = () => {
    const { t } = useLanguage();

    return (
        <section className="hero" id="hero">
            <div className="hero-image-container">
                <picture>
                    <source srcSet={require('../images/test1.webp')} type="image/webp" />
                    <img
                        src={require('../images/test1.png')}
                        alt="Brooklyn Community Christian Church"
                        className="hero-image"
                    />
                </picture>
            </div>

            <div className="hero-content">
                <div className="hero-card">
                    <span className="hero-label">{t('hero.label')}</span>
                    <h1 className="hero-title">
                        {t('hero.title')}
                    </h1>
                    <p className="hero-subtitle">
                        {t('hero.subtitle')}
                    </p>
                    <div className="hero-actions">
                        <HashLink smooth to='/#service-info'>
                            <button className="btn-primary">{t('hero.cta')}</button>
                        </HashLink>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
